import { CrudModel } from './_crud';
import { crudCreate } from "./_request";

import companyModel from './company.model';

export class VoucherModel extends CrudModel {
	public afterCreateMessage = 'Vouchers Criados com sucesso';

	constructor() {
		super('admin/voucher', [], [{ fieldKey: 'company', model: companyModel }]);
	}

	async create(data: any) {
		//console.log('voucher create');
		try {
			const endpoint = 'admin/voucher/lote';
			return (await crudCreate(endpoint, data)); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}
}

export default new VoucherModel();
